import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import P2 from '@base/P2/P2';
import Divider from '@base/Divider/Divider';

const UNDivider = styled(Divider)`
  margin: 16px 0;
  background-color: var(--color-shadow);
`;

const MessageDivider = ({ message }) => {
  if (!message) return null;
  return (
    <>
      <P2 color="var(--color-text-primary)">{message}</P2>
      <UNDivider />
    </>
  );
};

export default MessageDivider;

MessageDivider.propTypes = {
  message: PropTypes.string
};

MessageDivider.defaultProps = {
  message: null
};
